import React, { useEffect, useState } from 'react'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import { USER_WHITE_LIST_AUTH, RECOMMEND_POST } from '~/graphqls/gqls'
import {
  userWhiteListAuth,
  userWhiteListAuthVariables,
  WhitelistType,
  WhitelistStatus,
  recommnedPost,
  recommnedPostVariables,
  ActionType,
} from '~/graphqls/types'
import { useMutation } from '@apollo/client'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { graphQLErrorMessage } from '~/utils'

import classNames from 'classnames'
import { MyIcon } from '~/components/ui/MyIcon'
import { message, Modal } from 'antd'

export const Recommend: React.FC<{
  className?: string
  postId: number | null | undefined
  recommend?: boolean | null
  isSquare?: boolean
}> = ({ className, postId, recommend = false, isSquare }) => {
  const { validateIsLogin } = useValidateAuth()
  const [isRecommended, setIsRecommended] = useState(recommend)
  const [userWhitelistStatus, setUserWhitelistStatus] =
    useState<WhitelistStatus>(WhitelistStatus.NONE) // 用户是否在在白名单内

  const [recommendAction, { loading: uploading }] = useMutation<
    recommnedPost,
    recommnedPostVariables
  >(RECOMMEND_POST)
  const fetchUserWhiteList = useImperativeQuery<
    userWhiteListAuth,
    userWhiteListAuthVariables
  >(USER_WHITE_LIST_AUTH)

  /** 推荐帖子 */
  const handleRecommend = async () => {
    try {
      const res = await recommendAction({
        variables: {
          id: postId,
          actionType: isRecommended ? ActionType.CANCEL : ActionType.CONFIRM,
        },
      })
      if (res.data?.squareModule?.success) {
        message.destroy()
        message.success(`${isRecommended ? '移除' : '推荐'}成功`)
        setIsRecommended(!isRecommended)
      }
    } catch (error) {
      message.destroy()
      setIsRecommended(!isRecommended)
      message.error(
        graphQLErrorMessage(error) || `${isRecommended ? '移除' : '推荐'}失败`
      )
    }
  }
  const handleClick = () => {
    if (!validateIsLogin()) return
    if (!postId) return
    if (uploading) return
    if (isRecommended) {
      Modal.confirm({
        title: '提示',
        maskStyle: {
          backgroundColor: 'rgba(0,0,0,0.8)',
        },
        width: 270,
        className: 'hookModal dark',
        content: (
          <div className="text-neutral-400 text-sm text-center">
            确认将该作品移除推荐吗？
          </div>
        ),
        okText: '确认',
        onOk: handleRecommend,
        cancelText: '取消',
        onCancel: close => {
          close()
        },
      })
    } else {
      handleRecommend()
    }
  }
  const getUserWhiteList = async () => {
    try {
      const res = await fetchUserWhiteList({
        writeListType: WhitelistType.SQUARE_ACTIVITY,
      })
      setUserWhitelistStatus(res?.data?.status as WhitelistStatus)
    } catch (error) {
      message.destroy()
      message.error(graphQLErrorMessage(error) || '未知错误')
    }
  }
  useEffect(() => {
    getUserWhiteList()
  }, [])
  if (userWhitelistStatus === WhitelistStatus.NONE) {
    return null
  }
  return (
    <>
      <div
        className={classNames(
          'flex items-center cursor-pointer transition-colors',
          className,
          { ['!text-[#FFD600;]']: isRecommended }
        )}
        onClick={handleClick}
      >
        <MyIcon
          icon={isRecommended ? 'tuijianmianxing' : 'tuijian'}
          className="text-base"
        />
        {!isSquare && (
          <span className="text-xs leading-none ml-1">
            {isRecommended ? '移除推荐' : '推荐'}
          </span>
        )}
      </div>
    </>
  )
}
